// extracted by mini-css-extract-plugin
export default {"container":"shackClosing_container__4b42u","wrapper":"shackClosing_wrapper__7++3b"};